import React, { useState } from "react"
import { Navigate } from "react-router-dom"
import getAppConfig from "~/utils/getAppConfig"
import { useToast } from "~/utils/Toast"

import { apiWorkspaceDeals, apiWorkspaceDealStages } from "~/routes"
import useFetchResource from "~/hooks/useFetchResource"

import PageContainer from "~/library/PageContainer"
import LoadingWrapper from "~/library/LoadingWrapper"
import DealForm from "./DealForm"

type DealStageOption = {
    id: string
    name: string
}

const NewDeal = () => {
    const { venueSlug } = getAppConfig()
    const [createdDealId, setCreatedDealId] = useState<string | null>(null)
    const toast = useToast()

    const { data: dealStages, isLoading: stagesLoading } = useFetchResource<
    DealStageOption[],
    "deal_stages"
    >(apiWorkspaceDealStages.index.path({ venue_slug: venueSlug }), "deal_stages", {})

    const handleSubmit = (formValues: any) => {
        const data = {
            venue_slug: venueSlug,
            deal: formValues,
        }

        const req = apiWorkspaceDeals.create({ data })

        req
            .then((response) => {
                if (response.status === "ok") {
                    setCreatedDealId(response.prefixId)
                    toast("Deal created successfully", "success")
                } else {
                    toast(
                        `Error creating deal. ${response.errors?.join(", ") || "Please try again"}`,
                        "danger"
                    )
                }
            })
            .catch((res) => {
                const errorMessage =
                    res.body?.errors?.join(", ") ||
                    res.body?.error ||
                    "Please try again"
                toast(`Error creating deal. ${errorMessage}`, "danger")
            })
    }

    if (createdDealId) {
        return <Navigate to={`/deals/${createdDealId}`} />
    }

    return (
        <PageContainer>
            <LoadingWrapper isLoading={stagesLoading}>
                <div className="row h-100">
                    <div className="col-8 offset-2 align-center mt-4">
                        <h3 className="mb-3">New Deal</h3>
                        {dealStages && (
                            <DealForm
                                onSubmit={handleSubmit}
                                dealStages={dealStages}
                            />
                        )}
                    </div>
                </div>
            </LoadingWrapper>
        </PageContainer>
    )
}

export default NewDeal
